<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <v-layout justify-center class="login-form">
            <v-flex xs12 sm9 md4 mb-12>
                <div class="form-login-alert-error" v-if="loginError">
                    <v-layout justify-center class="mt-12 py-2 alert-error">
                        <v-flex xs12>
                            <v-flex ml-4 style="position: absolute">
                                <v-icon style="color: #fff; text-align: left">error_outline</v-icon>
                            </v-flex>
                            *ท่านไม่สามารถเข้าสู่ระบบได้?
                            <a href="#" style="color: white; font-size: 16px">ลืมรหัสผ่าน?</a>
                        </v-flex>
                    </v-layout>
                </div>
                <v-card flat class="pa-7 login-card border-bottom-form"
                        :class="{'mt-12': !loginError, 'mb-4': !loginError , 'border-top-form': !loginError}">
                    <v-container v-if="!loginError">
                        <v-layout justify-center>
                            <v-flex xs4>
                                <img alt="Vue logo" src="../assets/logo.png" style="width: 100%">
                            </v-flex>
                        </v-layout>
                        <v-layout column>
                            <v-flex shrink class="text-color">
                                ลงชื่อเข้าใช้งาน <span style="font-size: 16px; color: red">(ผู้ใช้งาน)</span>
                            </v-flex>
                            <v-flex my-2>
                                <v-layout justify-center>
                                    <v-flex xs6 sm5 md7>
                                        <!--                                    <v-divider width="100%" style="box-shadow: 0 2px 4px rgba(0,0,0,.25); color: #527281"></v-divider>-->
                                        <div style="border-top: solid 2px #527281; width: 100%; box-shadow: 0 3px 3px rgba(0,0,0,.25)"></div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex shrink>
                                ฐานข้อมูลกลาง
                            </v-flex>
                            <v-flex shrink>
                                คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-container v-if="loginError">
                        <v-layout justify-center>
                            <v-flex xs4>
                                <img alt="Vue logo" src="../assets/logo.png" style="width: 60%">
                            </v-flex>
                        </v-layout>
                        <v-layout column>
                            <v-flex shrink class="mb-6 text-color">
                                ลงชื่อเข้าใช้งาน
                            </v-flex>
                            <v-flex>
                                <v-layout justify-center>
                                    <v-flex xs12 style="font-size: 13px; color: #C03939">
                                        กรุณาตรวจสอบชื่อผู้ใช้ หรือรหัสผ่านให้ถูกต้อง และลองใหม่อีกครั้ง
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-layout justify-center my-2>
                        <v-flex xs10>
                            <v-form ref="form" v-model="formHasErrors" lazy-validation>
                                <v-flex v-if="loginError" style="text-align: left; color: #C03939">*อีเมล</v-flex>
                                <v-text-field class="ma-0 pa-0"
                                        v-model="form.email"
                                        :background-color="!loginError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                        :class="{'form-login-error': loginError}"
                                        dark
                                        :placeholder="!loginError ? 'username' : ''"
                                        :rules="emailRules"
                                        :prepend-inner-icon="!loginError ? 'account_circle' : '' "
                                        solo
                                ></v-text-field>
                                <v-flex v-if="loginError" style="text-align: left; color: #C03939">*รหัส</v-flex>
                                <v-text-field
                                        v-model="form.password"
                                        dark
                                        :class="{'form-login-error': loginError}"
                                        type="password"
                                        :background-color="!loginError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                        :placeholder="!loginError ? 'password' : ''"
                                        :rules="passRules"
                                        :prepend-inner-icon="!loginError ? 'lock' : '' "
                                        solo
                                        required
                                ></v-text-field>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-layout class="offset-2" v-if="loginError">
                    <v-flex xs10>
                        <v-flex class="checkbox-field">
                            <v-checkbox
                                label="จำรหัสผ่าน?"
                                v-model="checkbox"
                                color="success"
                            >
                            </v-checkbox>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs12>
                        <v-btn
                               style="border-radius: 30px; width: 150px; background-color: #527281; color: #fff"
                               class="ma-2 xs6 md6" @click="submit">เข้าสู่ระบบ
                        </v-btn>
                        <v-btn v-if="!loginError"
                                style="border-radius: 30px; width: 150px; background-color: #527281; color: #fff"
                               class="ma-2 md6" @click="$router.push('/register').catch(err => {})">
                            ลงทะเบียน
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout justify-center mt-6 v-if="!loginError">
                    <v-flex xs6 sm5 md7>
                        <div style="border-top: solid 2px #527281; width: 100%; box-shadow: 0 2px 2px rgba(0,0,0,.25)"></div>
                    </v-flex>
                </v-layout>

                <v-btn v-if="!loginError" text large style="color: #527281;">ลืมรหัสผ่าน?</v-btn>

            </v-flex>
        </v-layout>
        <Footer></Footer>
    </v-content>
</template>

<script>
    import validate from "../utils/validate";
    import Footer from '@/components/Footer.vue';


    export default {
        name: "login",
        components: {
            Footer
        },
        data: () => ({
            form: {
                email: "",
                password: "",
            },
            checkbox: false,
            formHasErrors: false,
            loginError: false,
            emailRules: [
                // v => validate.validEmail(v, "email"),
                v => validate.required(v, "username"),
            ],
            passRules: [
                v => validate.required(v, "password"),
            ],
        }),

        methods: {
            submit () {
                this.$store.dispatch('Auth/login', {
                    username: this.form.email,
                    password: this.form.password,
                })
                    .then((data) => {
                        if (data.success.user.type === '1') {
                            alert('บัญชีผู้ใช้ไม่ถูกต้อง')
                            return Promise.reject()
                        }
                        this.goToHomePage();
                    })
                    .catch(err => {
                       if(err.response.status === 401) {
                           alert(err.response.data.error)
                       } else {
                           console.log(500)
                       }
                    })
            },
            goToHomePage(){
                this.$router.push({
                    name:"home"
                }).catch(err => {});
                // this.$router.push(`/home/${data}`);
            },
        },
    }

</script>

<style lang="scss" scoped>
    .text-color {
        color: #84A2A8;
        font-size: 26px;
        font-weight: bold;
    }
    .form-login-error {
        /*background-color: rgba(192, 57, 57, 0.1);*/
    }
    .form-login-success {
        background-color: #527281;
    }
    .login-form {
        .v-input--selection-controls {

        }
        .login-card {
            background: rgba(255,255,255,.18) !important;
        }
        .border-top-form {
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }
        .border-bottom-form {
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }
    }
    .form-login-alert-error {
        .alert-error {
            /*background: rgba(255,255,255,.01);*/
            font-size: 16px;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            background-color: #C03939;
            color: white;
        }
    }
    .form-login-error {
        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
            border-style: solid;
            border-color: #C03939!important;
            border-width: 1px;
        }
        .theme--dark.v-input:not(.v-input--is-disabled) input, .theme--dark.v-input:not(.v-input--is-disabled) textarea {
            color: #527281;
        }
    }
</style>
<style lang="scss">
    .form-login-error.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
        border-color: #C03939 !important;
        border-width: 1px;
        border-style: solid;
    }

    .form-login-error.theme--dark.v-input:not(.v-input--is-disabled) input, .theme--dark.v-input:not(.v-input--is-disabled) textarea {
        color: #000000;
    }
    .checkbox-field {
        .v-icon.v-icon {
            color: #C03939;
        }
        .v-input--selection-controls.v-input .v-label {
            color: #C03939;
        }
    }
</style>
